import { useTypedSelector } from '../store';
import { selectActivityLog, selectLoading } from '../store/changelog/selectors';
import { useDispatch } from 'react-redux';
import { fetchChangeLog } from '../store/changelog/actionWrapper';

export default function useChangeLog() {
  const dispatch = useDispatch();
  const changeLog = useTypedSelector(selectActivityLog);
  const fetchChangeLogHandler = (projectId: string) =>
    dispatch(fetchChangeLog(projectId));
  const loading = useTypedSelector(selectLoading);
  return { changeLog, fetchChangeLogHandler, loading };
}
